// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jotai from "jotai";
import * as Caml_obj from "rescript/lib/es6/caml_obj.js";
import * as CardTheme$OrcaPaymentPage from "../CardTheme.bs.js";
import * as CommonHooks$OrcaPaymentPage from "../Hooks/CommonHooks.bs.js";
import * as ElementType$OrcaPaymentPage from "../Types/ElementType.bs.js";
import * as LoggerUtils$OrcaPaymentPage from "./LoggerUtils.bs.js";
import * as PaymentType$OrcaPaymentPage from "../Types/PaymentType.bs.js";
import * as PortalState$OrcaPaymentPage from "../Hooks/PortalState.bs.js";
import * as VaultHelpers$OrcaPaymentPage from "../Payments/VaultHelpers.bs.js";
import * as JotaiAtomTypes$OrcaPaymentPage from "../Types/JotaiAtomTypes.bs.js";
import * as PaymentMethodCollectUtils$OrcaPaymentPage from "./PaymentMethodCollectUtils.bs.js";

var keys = Jotai.atom(CommonHooks$OrcaPaymentPage.defaultkeys);

var configAtom = Jotai.atom(CardTheme$OrcaPaymentPage.defaultJotaiConfig);

var portalNodes = Jotai.atom(PortalState$OrcaPaymentPage.defaultDict);

var elementOptions = Jotai.atom(ElementType$OrcaPaymentPage.defaultOptions);

var optionAtom = Jotai.atom(PaymentType$OrcaPaymentPage.defaultOptions);

var sessions = Jotai.atom("Loading");

var updateSession = Jotai.atom(false);

var isTokenize = Jotai.atom(false);

var paymentMethodList = Jotai.atom("Loading");

var sdkConfigs = Jotai.atom("Loading");

var loggerAtom = Jotai.atom(LoggerUtils$OrcaPaymentPage.defaultLoggerConfig);

var sessionId = Jotai.atom("");

var isConfirmBlocked = Jotai.atom(false);

var customPodUri = Jotai.atom("");

var selectedOptionAtom = Jotai.atom("");

var paymentTokenAtom = Jotai.atom(JotaiAtomTypes$OrcaPaymentPage.defaultPaymentToken);

var showPaymentMethodsScreen = Jotai.atom(false);

var vaultCredentials = Jotai.atom(VaultHelpers$OrcaPaymentPage.defaultVaultCredentials);

var phoneJson = Jotai.atom("Loading");

var cardBrand = Jotai.atom("");

var paymentMethodCollectOptionAtom = Jotai.atom(PaymentMethodCollectUtils$OrcaPaymentPage.defaultPaymentMethodCollectOptions);

var payoutDynamicFieldsAtom = Jotai.atom(PaymentMethodCollectUtils$OrcaPaymentPage.defaultPayoutDynamicFields(undefined));

var paymentMethodTypeAtom = Jotai.atom(PaymentMethodCollectUtils$OrcaPaymentPage.defaultPmt(undefined));

var formDataAtom = Jotai.atom(PaymentMethodCollectUtils$OrcaPaymentPage.defaultFormDataDict);

var validityDictAtom = Jotai.atom(PaymentMethodCollectUtils$OrcaPaymentPage.defaultValidityDict);

var defaultFieldValues = {
  value: "",
  errorString: ""
};

var userFullName = Jotai.atom(defaultFieldValues);

var userEmailAddress = Jotai.atom(defaultFieldValues);

var newrecord = Caml_obj.obj_dup(defaultFieldValues);

var userPhoneNumber = Jotai.atom((newrecord.countryCode = "", newrecord));

var userCardNickName = Jotai.atom(defaultFieldValues);

var isGooglePayReady = Jotai.atom(false);

var trustPayScriptStatus = Jotai.atom("NotLoaded");

var isApplePayReady = Jotai.atom(false);

var isSamsungPayReady = Jotai.atom(false);

var isVgsScriptReady = Jotai.atom(true);

var isSavedCardCvcFlow = Jotai.atom(false);

var userCountry = Jotai.atom("");

var userBank = Jotai.atom("");

var userAddressline1 = Jotai.atom(defaultFieldValues);

var userAddressline2 = Jotai.atom(defaultFieldValues);

var userAddressCity = Jotai.atom(defaultFieldValues);

var userAddressPincode = Jotai.atom(defaultFieldValues);

var userAddressState = Jotai.atom(defaultFieldValues);

var userAddressCountry = Jotai.atom(defaultFieldValues);

var userBlikCode = Jotai.atom(defaultFieldValues);

var userGiftCardNumber = Jotai.atom(defaultFieldValues);

var userGiftCardPin = Jotai.atom(defaultFieldValues);

var fieldsComplete = Jotai.atom(false);

var isManualRetryEnabled = Jotai.atom(false);

var userCurrency = Jotai.atom("");

var cryptoCurrencyNetworks = Jotai.atom("");

var isShowOrPayUsing = Jotai.atom(false);

var isShowOrPayUsingWhileLoading = Jotai.atom(false);

var areRequiredFieldsValid = Jotai.atom(true);

var areRequiredFieldsEmpty = Jotai.atom(false);

var dateOfBirth = Jotai.atom(null);

var userBillingName = Jotai.atom(defaultFieldValues);

var userVpaId = Jotai.atom(defaultFieldValues);

var userPixKey = Jotai.atom(defaultFieldValues);

var userPixCPF = Jotai.atom(defaultFieldValues);

var userPixCNPJ = Jotai.atom(defaultFieldValues);

var userDocumentType = Jotai.atom("");

var userDocumentNumber = Jotai.atom(defaultFieldValues);

var isCompleteCallbackUsed = Jotai.atom(false);

var isPaymentButtonHandlerProvidedAtom = Jotai.atom(false);

var userBankAccountNumber = Jotai.atom(defaultFieldValues);

var sourceBankAccountId = Jotai.atom(defaultFieldValues);

var defaultAreOneClickWalletsRendered = {
  isGooglePay: false,
  isApplePay: false,
  isPaypal: false,
  isKlarna: false,
  isSamsungPay: false
};

var areOneClickWalletsRendered = Jotai.atom(defaultAreOneClickWalletsRendered);

var defaultClickToPayConfig_availableCardBrands = [];

var defaultClickToPayConfig_consumerIdentity = {
  identityType: "EMAIL_ADDRESS",
  identityValue: ""
};

var defaultClickToPayConfig = {
  availableCardBrands: defaultClickToPayConfig_availableCardBrands,
  email: "",
  dpaName: "",
  clickToPayProvider: "NONE",
  visaComponentState: "NONE",
  maskedIdentity: "",
  otpError: "",
  consumerIdentity: defaultClickToPayConfig_consumerIdentity
};

var clickToPayConfig = Jotai.atom(defaultClickToPayConfig);

var defaultRedirectionFlags = {
  shouldUseTopRedirection: false,
  shouldRemoveBeforeUnloadEvents: false
};

var redirectionFlagsAtom = Jotai.atom(defaultRedirectionFlags);

var isTestMode = Jotai.atom(false);

var isUpdateIntentLoading = Jotai.atom(false);

export {
  keys ,
  configAtom ,
  portalNodes ,
  elementOptions ,
  optionAtom ,
  sessions ,
  updateSession ,
  isTokenize ,
  paymentMethodList ,
  sdkConfigs ,
  loggerAtom ,
  sessionId ,
  isConfirmBlocked ,
  customPodUri ,
  selectedOptionAtom ,
  paymentTokenAtom ,
  showPaymentMethodsScreen ,
  vaultCredentials ,
  phoneJson ,
  cardBrand ,
  paymentMethodCollectOptionAtom ,
  payoutDynamicFieldsAtom ,
  paymentMethodTypeAtom ,
  formDataAtom ,
  validityDictAtom ,
  defaultFieldValues ,
  userFullName ,
  userEmailAddress ,
  userPhoneNumber ,
  userCardNickName ,
  isGooglePayReady ,
  trustPayScriptStatus ,
  isApplePayReady ,
  isSamsungPayReady ,
  isVgsScriptReady ,
  isSavedCardCvcFlow ,
  userCountry ,
  userBank ,
  userAddressline1 ,
  userAddressline2 ,
  userAddressCity ,
  userAddressPincode ,
  userAddressState ,
  userAddressCountry ,
  userBlikCode ,
  userGiftCardNumber ,
  userGiftCardPin ,
  fieldsComplete ,
  isManualRetryEnabled ,
  userCurrency ,
  cryptoCurrencyNetworks ,
  isShowOrPayUsing ,
  isShowOrPayUsingWhileLoading ,
  areRequiredFieldsValid ,
  areRequiredFieldsEmpty ,
  dateOfBirth ,
  userBillingName ,
  userVpaId ,
  userPixKey ,
  userPixCPF ,
  userPixCNPJ ,
  userDocumentType ,
  userDocumentNumber ,
  isCompleteCallbackUsed ,
  isPaymentButtonHandlerProvidedAtom ,
  userBankAccountNumber ,
  sourceBankAccountId ,
  defaultAreOneClickWalletsRendered ,
  areOneClickWalletsRendered ,
  defaultClickToPayConfig ,
  clickToPayConfig ,
  defaultRedirectionFlags ,
  redirectionFlagsAtom ,
  isTestMode ,
  isUpdateIntentLoading ,
}
/* keys Not a pure module */
